// External libraries
import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';

// Internal modules
import {
  DEFAULT_BORDER_COLOR,
  DISABLED_BACKGROUND_COLOR,
  ERROR_COLOR,
  PRIMARY_COLOR_V2,
} from '@/styles';

const getRadioBoxShadow = ({
  displayError,
  disabled,
}: {
  displayError?: boolean;
  disabled?: boolean;
}) => {
  if (disabled) {
    return `inset 0 0 0 100px ${DISABLED_BACKGROUND_COLOR}`;
  }

  return `inset 0 0 0 1px ${displayError ? ERROR_COLOR : DEFAULT_BORDER_COLOR}`;
};

export const getCommonRadioButtonStyleOverrides = ({
  displayError,
  disabled,
  labelFontSize,
  radioButtonContainerMargin,
}: {
  displayError?: boolean;
  disabled?: boolean;
  labelFontSize?: string;
  radioButtonContainerMargin?: string;
}): { [key: string]: SerializedStyles } => {
  const overrides = {
    containerStyleOverrides: css`
      margin: ${radioButtonContainerMargin};
    `,

    inputStyleOverrides: css`
      &:checked + label::before {
        box-shadow: inset 0 0 0 8px ${PRIMARY_COLOR_V2};
      }

      &:focus + label::before {
        box-shadow: inset 0 0 0 8px ${PRIMARY_COLOR_V2};
        outline: 2px solid ${PRIMARY_COLOR_V2};
        outline-offset: 2px;
      }
    `,

    labelStyleOverrides: css`
      cursor: ${disabled ? 'default' : 'pointer'};
      font-weight: 400;
      font-size: ${labelFontSize};
      min-width: 100px;
      line-height: 24px;

      &::before {
        box-shadow: ${getRadioBoxShadow({ disabled, displayError })};
      }
    `,
  };
  return overrides;
};
